import React, { Component } from 'react';
import { Row, Space } from 'antd';
import styles from '../activityLog/index.scss';

class TypologyDetailsTab extends Component {
  render() {
    return (
      <Row>
        <Space direction={'vertical'}>
          <Row className={styles.flexVertical}>
            <div style={{ color: '#31394D', fontWeight: 500, marginBottom: 5 }}>
              Description
            </div>
            <div>
              Description: The private aircraft manufacturer sells the small
              aircrafts to government office overseas. To sell more aircrafts,
              the organization offers kickbacks for the purchase officer via
              cryptocurrency.
            </div>
          </Row>
          <Row className={styles.flexVertical}>
            <div className={styles.flexHorizontal}>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
            </div>
            <div className={styles.flexHorizontal}>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
            </div>
            <div className={styles.flexHorizontal}>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
              <div className={styles.flexVertical}>
                <div className={styles.labelHeader}>Product</div>
                <div className={styles.labelDesc}>Pilot</div>
              </div>
            </div>
          </Row>
        </Space>
      </Row>
    );
  }
}

TypologyDetailsTab.propTypes = {};

export default TypologyDetailsTab;
